import IndependentCharterSubtypeForm from './IndependentCharterSubtypeForm.component';

export default IndependentCharterSubtypeForm;